import {PropsWithChildren} from 'react';
import styles from './styles.module.less';
import {join} from '@esgi/ui-kit/utils';

export const StepFooter = ({children, className}: PropsWithChildren & { className?: string }) => (
	<div className={join(styles.stepFooter, className)}>{children}</div>
);
